<template>
    <div>
        <TissuForm :model_id="model_id" :item="tissu" @save="goToModel" @edit="goToModel"/>
    </div>
</template>

<script>
import TissuForm from '@/components/forms/TissuForm.vue';

export default {
    name: 'TissuCreate',
    props: {
        model_id: {
            type: [String, Number],
            required: true
        },
        id:{
            type: [String, Number],
            required: false
        }
    },
    data() {
        return {
            tissu: {}
        }
    },
    components: {
        TissuForm
    },
    methods: {
         goToModel(tissu) {
            console.log(tissu)
            this.$router.push({ name: 'models.view', params: { id: tissu.style_id } });
        },
        getTissu() {
            if (this.id) {
                this.$api.get(`/tissus/${this.id}`)
                    .then(response => {
                        this.tissu = response.data.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    },
    created() {
        this.getTissu()
    }
}
</script>